import { Pipe, PipeTransform } from '@angular/core';
import { CardsThatLayoutOntoPaper } from '../../../models/menu/section/cards-that-layout-onto-paper';

@Pipe({
  name: 'isOnPerforatedPaper',
  standalone: false
})
export class IsOnPerforatedPaperPipe implements PipeTransform {
  transform(cardsThatLayoutOntoPaper: CardsThatLayoutOntoPaper): boolean {
    return cardsThatLayoutOntoPaper?.isOnPerforatedPaper() || false;
  }
}
